import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import PropTypes from 'prop-types';
import {List} from 'immutable';
import {Map} from 'immutable';
import ReactModal from 'react-modal';

import {Divider} from 'components/common';
import {Wrapper} from 'system/wrapper';
import Rating from './rating';
import {DetailList, Image, DetailInfoWrapper} from './components';
import Breadcrumbs from '../../breadcrumbs';
import Spinner from 'spinner';
import {Actions} from 'components/actions';
import Input from 'form/input';
import Textarea from 'form/textarea';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {LinkDefault, ButtonWrap, ButtonDefault, ButtonSuccess, ButtonDanger} from 'components/buttons';

import {loadUser} from 'redux/actions/auth';
import {loadReception} from 'redux/actions/portal/records';
import {loadInstitutionPersonalDetail, changeAccostValue, submitAccost, submitRating, checkRating, cleanAccostForm, cleanInstitutionPersonalDetails} from 'redux/actions/portal/institutions';

import doctor from 'images/general/doctor.svg';
import close from 'images/general/close.svg';

const mapStateToProps = (state) => ({
  detail: state.institutions.get('institutionPersonalDetail'),
  isFetching: state.institutions.get('institutionsIsLoading'),
  accost: state.institutions.get('accost'),
  user: state.auth.get('user'),
  token: state.auth.get('token'),
  accostDetail: state.institutions.get('accostDetail'),
  ratingDetail: state.institutions.get('ratingDetail')
});

const mapDispatchToProps = (dispatch) => ({
  onLoad: (doctor) => {
    dispatch(loadUser())
    dispatch(loadReception(doctor))
    dispatch(loadInstitutionPersonalDetail(doctor))
  },
  loadInstitutionPersonalDetail: doctor => dispatch(loadInstitutionPersonalDetail(doctor)),
  checkRating: (user_id, staff_id) => dispatch(checkRating(user_id, staff_id)),
  onChangeAccost: (value, key) => dispatch(changeAccostValue(value, key)),
  onSubmit: (staff_id, institution_id, user_id, type) => {
    dispatch(submitAccost(staff_id, institution_id, user_id, type))
    dispatch(cleanAccostForm())
  },
  submitRating: (staff_id, user_id, rating, comment) => dispatch(submitRating(staff_id, user_id, rating, comment)),
  onClean: () => dispatch(cleanAccostForm()),
  cleanDetails: () => dispatch(cleanInstitutionPersonalDetails())

});

const changeRating = rating => {
  if (rating === 0) {
    return <span style={{fontWeight: "normal"}}>Оцінки відсутні</span>
  }

  if (rating < 3) {
    return <span style={{color: "#df6050", fontWeight: "normal"}}>{rating}</span>
  }

  if (rating >= 3 && rating < 4) {
    return <span style={{color: "#edbd2f", fontWeight: "normal"}}>{rating}</span>
  }

  if (rating >= 4) {
    return <span style={{color: "#00CE00", fontWeight: "normal"}}>{rating}</span>
  }
}

class InstitutionPersonalDetail extends Component {

  multilineStyle = {
    whiteSpace: 'pre-wrap',
    lineHeight: '1.3'
  }

  constructor(props) {
    super(props);

    this.state = {
      modalOpenGratitude: false,
      modalOpenComplaint: false,
      modalOpenRating: false,
      modalOpenRegistration: false,
      step1: true,
      step2: false,
      step3: false,
      selectValue: '5',
      comment: "",
      error: false
    };
    this.toggleModalGratitude = this.toggleModalGratitude.bind(this);
    this.toggleModalComplaint = this.toggleModalComplaint.bind(this);
    this.toggleModalRating = this.toggleModalRating.bind(this);
    this.toggleModalRegistration = this.toggleModalRegistration.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.changeComment = this.changeComment.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.openStep1 = this.openStep1.bind(this);
    this.openStep2 = this.openStep2.bind(this);
    this.openStep3 = this.openStep3.bind(this);
    this.StepNotForRating = this.StepNotForRating.bind(this);
  }

  openStep1() {
    this.setState({
      step1: true,
      step2: false,
      step3: false
    })
  }

  openStep2() {
    this.setState({
      step1: false,
      step2: true,
    })
  }

  StepNotForRating(){
    if (!this.props.accost.get('brief_description') || !this.props.accost.get('detail_description')){
      return this.setState({
        error: true
      })
    }
    this.setState({
      step1: false,
      step2: true,
    })
  }

  openStep3() {
    this.setState({
      step2: false,
      step1: false,
      step3: true
    })
  }

  handleChange(event) {
    this.setState({selectValue: event.target.value});
  }

  changeComment(event) {
    this.setState({comment: event.target.value});
  }

  toggleModalGratitude() {
    this.setState({
      modalOpenGratitude: !this.state.modalOpenGratitude,
      error: false
    });
  }

  toggleModalComplaint() {
    this.setState({
      modalOpenComplaint: !this.state.modalOpenComplaint,
      error: false
    });
  }

  toggleModalRating() {
    this.setState({
      modalOpenRating: !this.state.modalOpenRating,
      error: false
    });
  }

  toggleModalRegistration() {
    this.setState({
      modalOpenRegistration: !this.state.modalOpenRegistration,
      error: false
    });
  }

  closeModal() {
    this.setState({
      modalOpen: false,
      error: false
    })
  }

  componentDidMount() {
    this.props.onLoad(this.props.match.params.doctor);
  }

  componentWillUnmount () {
    this.props.cleanDetails()
  }

  render() {
    const item = this.props.detail;
   

    if (this.props.detail === undefined || this.props.detail.size === 0 || this.props.accost === undefined ) {
      return <Wrapper><Spinner/></Wrapper>;
    }

    if (this.props.detail.size === 0) {
      return <Wrapper><Spinner/></Wrapper>;
    }

    return(
      <div>
      {item.get('institution_data') &&
        <Breadcrumbs>
          <li><Link to="/">Головна</Link></li>
          <li><Link to="/institutions">Установи</Link></li>
          <li><Link to={`/institutions/detail/${item.get('institution_data').get('id')}`}>{item.get('institution_data').get('short_title')}</Link></li>
          <li><Link to={`/institutions/detail/${item.get('institution_data').get('id')}/personal`}>Персонал</Link></li>
          <li><Link to={`/institutions/detail/${item.get('institution_data').get('id')}/personal/${item.get('id')}`}>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')}</Link></li>
        </Breadcrumbs>
      }
        <Wrapper>
          {item.get('user_data') &&
            <Grid>
              <h2>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')}</h2>
              <DetailInfoWrapper>
              <Image>
                        {item.get('user_data').get('photo') ? (
                              <img src={item.get('user_data').get('photo')} alt="Лікарі"/>
                              ):(
                              <img src={doctor} alt="Лікарі"/>
                            )}
              </Image>
            
              <DetailList>
                <li style={this.multilineStyle}><span>Посада: </span>{item.get('position_title')}</li>
                <li style={this.multilineStyle}><span>Спеціальність: </span>{item.getIn(['doctor_data', 'profession_classification_data', 'profession_title'])}</li>
                <li style={this.multilineStyle}><span>Номер кабінета: </span>{item.get('cabinet_number')}</li>
                <li style={this.multilineStyle}><span>Телефон: </span>{item.get('phone')}</li>
                <li style={this.multilineStyle}><span>Графік роботи: </span><span style={{lineHeight: "1.3", fontWeight: "normal", whiteSpace: "pre-wrap"}}>{item.get('schedule')}</span></li>
                <li style={this.multilineStyle}><span>Рейтинг лікаря: </span>{item.get('rating_count') > 0 ? changeRating(item.get('rating').toFixed(2)) : "Оцінки відсутні"} {item.get('rating_count') > 0 ? <span style={{fontWeight: "normal"}}> (Кількість оцінок: {item.get('rating_count')})</span> : null}</li>
                <li style={this.multilineStyle}><span>Додаткова інформація: </span>{item.get('comment') || "Додаткова інформація відсутня"}</li>
              </DetailList>
              </DetailInfoWrapper>
              <Divider>
                {this.props.token ? (
                  <LinkDefault to={`/institutions/detail/${item.get('institution_data').get('id')}/personal/${item.get('id')}/record`}>Записатися на прийом</LinkDefault>
                ): (
                  <ButtonDefault onClick={this.toggleModalRegistration} value="Записатися до лікаря"/>
                )}
              </Divider>
              <Divider>
                <Actions>
                  <li>
                    <ButtonDefault onClick={this.toggleModalRating} value="Поставити оцінку"/>
                  </li>
                  <li>
                    <ButtonSuccess onClick={this.toggleModalGratitude} value="Залишити подяку"/>
                  </li>
                  <li>
                    <ButtonDanger onClick={this.toggleModalComplaint} value="Залишити скаргу"/>
                  </li>
                </Actions>
              </Divider>
            </Grid>
          }


        </Wrapper>



        <ReactModal isOpen={this.state.modalOpenRegistration} onRequestClose={() => {
          this.toggleModalRegistration()
        }}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <Modal>
            <CloseModal>
              <div onClick={(event) => {
                this.toggleModalRegistration()
              }}>
                 <img src={close} alt="закрити" />
              </div>
            </CloseModal>

            <ModalContent>
              <h3>Для того, щоб записатися до лікаря потрібно бути користувачем системи</h3>
              <Divider>
              <h3>Якщо Ви зареєстрований користувач, <Link style={{color: "#edbd2f"}} to='/login'>увійдіть</Link> на портал</h3>
                <h3>Зареєструватися можна за цим <Link style={{color: "#edbd2f"}} to='/registration'>посиланням</Link></h3>
              </Divider>
            </ModalContent>

          </Modal>

        </ReactModal>


        <ReactModal isOpen={this.state.modalOpenGratitude} onRequestClose={() => {
          this.toggleModalGratitude()
          this.props.onClean()
          this.openStep1()
        }}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <Modal>
            <CloseModal>
              <div onClick={(event) => {
                this.toggleModalGratitude()
                this.openStep1()
              }}>
				         <img src={close} alt="закрити" />
              </div>
						</CloseModal>
            {!this.props.token ? (
              <ModalContent>
                <h3>Для того, щоб залишити подяку потрібно бути користувачем системи</h3>
                <Divider>
                <h3>Якщо Ви зареєстрований користувач, <Link style={{color: "#edbd2f"}} to='/login'>увійдіть</Link> на портал</h3>
                  <h3>Зареєструватися можна за цим <Link style={{color: "#edbd2f"}} to='/registration'>посиланням</Link></h3>
                </Divider>
              </ModalContent>
            ): (
            <div>
            {this.state.step1 &&
            <ModalContent>
              <h3>Подяка лікарю</h3>
              {this.state.error ? (
                <span style={{color: "#ed0000"}}>Всі поля обов'язкові до заповнення</span>
              ): (
                null
              )}
              
              <Input
                block
                label="Короткий опис"
                required
                value={this.props.accost.get('brief_description') ? this.props.accost.get('brief_description') : ""}
                onChange={(event) => this.props.onChangeAccost(event.target.value, 'brief_description')}
                placeholder="Введіть короткий опис"
              />
              <Textarea
                block
                required
                label="Детальний опис"
                value={this.props.accost.get('detail_description') ? this.props.accost.get('detail_description') : ""}
                onChange={(event) => this.props.onChangeAccost(event.target.value, 'detail_description')}
                placeholder="Введіть детальний опис"
              />
              <ButtonWrap>
              
                <ButtonDefault onClick={this.StepNotForRating} value="Попередній перегляд" />
                <ButtonDefault  value="Скасувати" onClick={(event) => {
                  this.toggleModalGratitude()
                  this.openStep1()
                }}/>
              </ButtonWrap>
            </ModalContent>
            }


            {this.state.step2 &&
            <ModalContent>
              <h3>Попередній перегляд подяки</h3>
              <Divider>
                <div>Лікар: <strong>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')}</strong></div>
              </Divider>
              <Divider>
                <div>Лікарня: <strong>{item.get('institution_data').get('full_title')}</strong></div>
              </Divider>
              <Divider>
                <div>Короткий опис: <strong>{this.props.accost.get('brief_description')}</strong></div>
              </Divider>
              <Divider>
                <div>Детальний опис: <strong style={{whiteSpace: "pre-wrap"}}>{this.props.accost.get('detail_description')}</strong></div>
              </Divider>
              <ButtonWrap>
                <ButtonDefault onClick={() => {
                  this.props.onSubmit(this.props.match.params.doctor, this.props.match.params.id, this.props.user.get('id'), "gratitude")
                  this.openStep3()
                }} value="Відправити" />
                <ButtonDefault  value="Скасувати" onClick={(event) => {
                  this.toggleModalGratitude()
                  this.openStep1()
                }}/>
              </ButtonWrap>
              </ModalContent>
                }
        

            {this.state.step3 &&
            <ModalContent>
              <h3>Ваша подяка опублікована</h3>
              <Divider>
                <h4>Дякуємо за те, що намагаєтесь зробити нас кращими!</h4>
              </Divider>
              <Divider>
                <h4>Переглянути стан Вашої подяки можна за цим <Link style={{color: "#edbd2f"}} to={this.props.accostDetail === undefined ? `/`:  `/cabinet/reviews/detail/${this.props.accostDetail.get('id')}`}>посиланням</Link></h4>
              </Divider>
              <ButtonWrap>
                <LinkDefault to={this.props.accostDetail === undefined ? `/`:  `/cabinet/reviews/detail/${this.props.accostDetail.get('id')}`}>До подяки</LinkDefault>
                <ButtonDefault onClick={() => {
                  this.toggleModalGratitude()
                  this.openStep1()
                }} value="До порталу" />
              </ButtonWrap>
            </ModalContent>
            }
          </div>
          )}
          </Modal>

        </ReactModal>


        <ReactModal isOpen={this.state.modalOpenComplaint} onRequestClose={() => {
          this.toggleModalComplaint()
          this.props.onClean()
          this.openStep1()
        }}
          className={{
            base: 'modalContent',
            afterOpen: 'myClass_after-open',
            beforeClose: 'myClass_before-close'
          }} contentLabel="Підтвердження запису"
          overlayClassName={{
            base: 'modalOverlay',
            afterOpen: 'myOverlayClass_after-open',
            beforeClose: 'myOverlayClass_before-close'
          }}>

          <Modal>
            <CloseModal>
              <div onClick={(event) => {
                this.toggleModalComplaint()
                this.openStep1()
              }}>
				         <img src={close} alt="закрити" />
              </div>
						</CloseModal>
            {!this.props.token ? (
              <ModalContent>
                <h3>Для того, щоб залишити скаргу потрібно бути користувачем системи</h3>
                <Divider>
                <h3>Якщо Ви зареєстрований користувач, <Link style={{color: "#edbd2f"}} to='/login'>увійдіть</Link> на портал</h3>
                  <h3>Зареєструватися можна за цим <Link style={{color: "#edbd2f"}} to='/registration'>посиланням</Link></h3>
                </Divider>
              </ModalContent>
            ):(
            <div>
            {this.state.step1 &&
            <ModalContent>
              <h3>Cкарга на лікаря</h3>
              {this.state.error ? (
                <span style={{color: "#ed0000"}}>Всі поля обов'язкові до заповнення</span>
              ): (
                null
              )}
              <Input
                block
                required
                label="Короткий опис"
                value={this.props.accost.get('brief_description') ? this.props.accost.get('brief_description') : ""}
                onChange={(event) => this.props.onChangeAccost(event.target.value, 'brief_description')}
                placeholder="Введіть короткий опис"
              />
              <Textarea
                block
                required
                label="Детальний опис"
                value={this.props.accost.get('detail_description') ? this.props.accost.get('detail_description') : ""}
                onChange={(event) => this.props.onChangeAccost(event.target.value, 'detail_description')}
                placeholder="Введіть детальний опис"
              />

              <ButtonWrap>

                <ButtonDefault onClick={this.StepNotForRating} value="Попередній перегляд" />
                <ButtonDefault  value="Скасувати" onClick={(event) => {
                  this.toggleModalComplaint()
                  this.openStep1()
                }}/>
              </ButtonWrap>
            </ModalContent>
            }
            
            {this.state.step2 && (!this.props.accost.get('brief_description') || !this.props.accost.get('detail_description')) ? (
              <ModalContent>
              <h4>Всі поля обов’язкові до заповнення</h4>
              </ModalContent>
            ):(
              <div>
              {this.state.step2 &&
                <ModalContent>
                  <h3>Попередній перегляд скарги</h3>
                  <Divider>
                    <div>Лікар: <strong>{item.get('user_data').get('last_name')} {item.get('user_data').get('first_name')} {item.get('user_data').get('middle_name')}</strong></div>
                  </Divider>
                  <Divider>
                    <div>Лікарня: <strong>{item.get('institution_data').get('full_title')}</strong></div>
                  </Divider>
                  <Divider>
                    <div>Короткий опис: <strong>{this.props.accost.get('brief_description')}</strong></div>
                  </Divider>
                  <Divider>
                    <div>Детальний опис: <strong style={{whiteSpace: "pre-wrap"}}>{this.props.accost.get('detail_description')}</strong></div>
                  </Divider>
    
    
                  <ButtonWrap>
                    <ButtonDefault onClick={() => {
                      this.props.onSubmit(this.props.match.params.doctor, this.props.match.params.id, this.props.user.get('id'), "complaint")
                      this.openStep3()
                    }} value="Відправити" />
                    <ButtonDefault  value="Скасувати" onClick={(event) => {
                      this.toggleModalComplaint()
                      this.openStep1()
                    }}/>
                  </ButtonWrap>
                </ModalContent>
              }
                </div>
            )
            }

           

            {this.state.step3 &&
            <ModalContent>
              <h3>Ваша скарга опублікована</h3>
              <Divider>
                <h4>Дякуємо за те, що намагаєтесь зробити нас кращими!</h4>
              </Divider>
              <Divider>
                <h4>Переглянути стан Вашої скарги можна за цим <Link style={{color: "#edbd2f"}} to={this.props.accostDetail === undefined ? `/`:  `/cabinet/reviews/detail/${this.props.accostDetail.get('id')}`}>посиланням</Link></h4>
              </Divider>
              <ButtonWrap>
                <LinkDefault to={this.props.accostDetail === undefined ? `/`:  `/cabinet/reviews/detail/${this.props.accostDetail.get('id')}`}>До скарги</LinkDefault>
                <ButtonDefault onClick={() => {
                  this.toggleModalComplaint()
                  this.openStep1()
                }} value="До порталу" />
              </ButtonWrap>
            </ModalContent>
            }
          </div>
          )}
          </Modal>

        </ReactModal>


        <Rating
          step1={this.state.step1}
          step2={this.state.step2}
          step3={this.state.step3}
          staff={this.props.detail}
          modalOpenRating={this.state.modalOpenRating}
          toggleModalRating={() => this.toggleModalRating()}
          openStep1={() => this.openStep1()}
          openStep2={() => this.openStep2()}
          openStep3={() => this.openStep3()}
          comment={this.state.comment}
          selectValue={this.state.selectValue}
          handleChange={this.handleChange}
          changeComment={(event) => this.changeComment(event)}
          checkRating={(user_id, staff_id) => this.props.checkRating(user_id, staff_id)}
          submitRating={(staff_id, user_id, rating, comment) => this.props.submitRating(staff_id, user_id, rating, comment)}
          ratingDetail={this.props.ratingDetail}
        />

      </div>
    )
  }
}

InstitutionPersonalDetail.propTypes = {
  detail: PropTypes.instanceOf(Map),
  institutions: PropTypes.instanceOf(List),
  isFetching: PropTypes.bool,
  onLoad: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(InstitutionPersonalDetail);



// WEBPACK FOOTER //
// ./src/system/main/institutions/personal-detail.js